import axios from "axios";

export default class ApiHandler {
    constructor() {
        this.HOST     = window.location.hostname;
        this.BASE_URL = '/wp-json/bnh/v1/';
    }

    get baseUrl() {
        return this.HOST + this.BASE_URL;
    }

    getApiUrl( endpoint = '' ) {
        return this.BASE_URL + endpoint;
    }

    getData( url ) {
        return new Promise(( resolve, rej ) => axios
            .get(url)
            .then(response => resolve(response.data)));
    }

    postData( url, data ) {
        return new Promise(( resolve, rej ) => axios
            .post(url, data)
            .then(response => resolve(response.data)));
    }

    getAppData() {
        return this.getData(this.getApiUrl('data/'));
    }

    getStorylines() {
        return this.getData(this.getApiUrl('storylines/'));
    }

    getInfoSpotByUrl(url) {
        return this.postData(this.getApiUrl('infospot/'), { 'url': url });
    }
}

export const API = new ApiHandler();
